/**
 * MyFlowers Club — общий слой правил корзины (MFS-5487).
 *
 * Зачем: одни и те же проверки были написаны заново в каждом файле, который
 * трогает корзину, и разошлись между собой — «строка членства» определялась
 * шестью способами, «скрытая строка» тремя, «тип Bouquet» четырьмя, причём с
 * разной чувствительностью к регистру. Здесь одно правило на каждую проверку
 * и одна операция на каждое изменение корзины.
 *
 * Константы и состояние клиента приходят из Liquid — snippets/js-variables.liquid
 * публикует window.PXUTheme.club. В этом файле id нет и быть не должно.
 *
 * Правила модуля:
 *   - конфиг читается ЛЕНИВО, внутри вызовов. Файл подключается раньше
 *     cart-service.js, и на верхнем уровне ни window.PXUTheme.club, ни
 *     window.CartService может ещё не быть.
 *   - ни одного запроса при подключении, кроме гигиены корзины на загрузке
 *     (runHygiene): она идёт в корзину только когда Liquid увидел в ней, что
 *     чистить (PXUTheme.club.hygiene.needed) или липкий order_source — на
 *     страницах, где корзина не нужна, модуль не стоит ни одного байта трафика.
 *   - предикаты чистые, без побочных эффектов. Отдельно важно для isHiddenLine:
 *     «скрытая» строка — это про отображение, а не про удаление. Тема однажды
 *     уже удаляла скрытые платные строки, съедала Service Fee, апп добавлял его
 *     обратно, и корзина зацикливалась (см. layout/theme.liquid).
 */
(function () {
  'use strict';

  // Чужой одноимённый глобал не перетираем — тот же приём, что в cart-service.js
  if (window.MFClub) return;

  const FALLBACK = {
    productId: 0,
    variantId: 0,
    membershipProductIds: [],
    membershipVariantIds: [],
    planTrial: 0,
    planRenew: 0,
    planId: 0,
    isMember: false,
    trialSpent: false,
    bouquetType: 'Bouquet',
    offerAttribute: 'club_offer',
    sourceAttribute: 'order_source',
    landingSource: 'landing',
    orderSource: '',
    hasLandingLine: false,
    hiddenProductTypes: ['mws_fee_generated'],
    hiddenSkuPrefix: '99',
    // product_id строк с метаполем myflower.hide_in_cart (его нет в /cart.js) —
    // считает Liquid по текущей корзине, snippets/js-variables.liquid
    hiddenProductIds: [],
    // Легаси подписочные товары/вариант/handle старых лендингов — в обычной
    // корзине ездить не должны; один список для Liquid и JS (js-variables.liquid)
    legacyProductIds: [],
    legacyVariantIds: [],
    legacyHandles: [],
    // Гигиена на загрузке: Liquid смотрит на корзину при рендере и говорит,
    // есть ли что чистить (needed → один GET /cart.js), и какие варианты в ней
    // клубные букеты (тег club-bouquet, кроме One time — тегов в /cart.js нет)
    // и открытки клуба (тег club-gift-card)
    hygiene: { needed: false, clubBouquetVariantIds: [], onetimeVariantIds: [], clubCardVariantIds: [] },
    // Ваза: товар из настроек (js-variables.liquid) либо свойство строки,
    // которое ставят оба тумблера (snippets/free-vase-checkbox.liquid).
    vaseProductId: 0,
    vaseProperty: '_free_vase',
    // Легаси-handle служебных строк: источник — snippets/js-variables.liquid
    serviceHandles: [],
  };

  function config() {
    const fromLiquid = (window.PXUTheme && window.PXUTheme.club) || {};
    return Object.assign({}, FALLBACK, fromLiquid);
  }

  function lines(cart) {
    return cart && Array.isArray(cart.items) ? cart.items : [];
  }

  // ─── Предикаты ──────────────────────────────────────────────────────────────

  // Членств два (MFS-5778): списки из js-variables.liquid, productId/variantId — старый контракт
  function idIn(list, single, value) {
    const n = Number(value);
    if (!n) return false;
    if (Number(single) === n) return true;
    return Array.isArray(list) && list.some((id) => Number(id) === n);
  }

  function isMembershipLine(item) {
    if (!item) return false;
    const cfg = config();
    return (
      idIn(cfg.membershipProductIds, cfg.productId, item.product_id) ||
      idIn(cfg.membershipVariantIds, cfg.variantId, item.variant_id) ||
      idIn(cfg.membershipVariantIds, cfg.variantId, item.id)
    );
  }

  // Регистронезависимо: функция скидки сравнивает product_type с "Bouquet"
  // точно, поэтому расхождение в регистре у товара разведёт тему и функцию.
  // Тема в такой ситуации должна вести себя мягче, а не строже.
  function isBouquetLine(item) {
    if (!item) return false;
    const type = (item.product_type || '').trim().toLowerCase();
    return type === String(config().bouquetType).trim().toLowerCase();
  }

  // Строка членства скрытой не считается никогда: она платная и видна в
  // чекауте, поэтому покупатель должен видеть её и в корзине, и в счётчике.
  function isHiddenLine(item) {
    if (!item) return false;
    if (isMembershipLine(item)) return false;

    const cfg = config();
    const type = (item.product_type || '').trim();
    if (cfg.hiddenProductTypes.indexOf(type) !== -1) return true;

    // то же правило, что у Liquid-счётчиков (метаполе hide_in_cart)
    if (idIn(cfg.hiddenProductIds, 0, item.product_id)) return true;

    const sku = typeof item.sku === 'string' ? item.sku : '';
    return cfg.hiddenSkuPrefix ? sku.indexOf(cfg.hiddenSkuPrefix) === 0 : false;
  }

  function membershipLines(cart) {
    return lines(cart).filter(isMembershipLine);
  }

  // Первая, а не последняя: при кратных строках членства (прецедент был в
  // MFS-5356) удалять надо ту, которую видит покупатель сверху.
  function findMembershipLine(cart) {
    return membershipLines(cart)[0] || null;
  }

  function hasBouquet(cart) {
    return lines(cart).some(isBouquetLine);
  }

  function isVaseLine(item) {
    if (!item) return false;
    const cfg = config();
    if (cfg.vaseProductId && Number(item.product_id) === Number(cfg.vaseProductId)) return true;
    const props = item.properties || {};
    return !!(cfg.vaseProperty && props[cfg.vaseProperty]);
  }

  // Служебная строка: сама по себе не покупка (сбор, членство, ваза, легаси-handle).
  // Корзина из одних служебных строк считается пустой и очищается целиком.
  function isServiceLine(item) {
    if (!item) return false;
    if (isHiddenLine(item) || isMembershipLine(item) || isVaseLine(item)) return true;
    const handles = config().serviceHandles;
    return Array.isArray(handles) && handles.indexOf(item.handle) !== -1;
  }

  /**
   * План удаления строк ОДНИМ /cart/update.js (CartService.updateLines):
   * вместе с keys снимаются сироты — членство без букета (и режим
   * club_offer), ваза без eligible-букета, а если остаются только служебные
   * строки — всё целиком. Раньше это были три-четыре запроса подряд:
   * change.js, затем снятие членства, затем heal вазы после перерисовки,
   * затем clear.js + update.js (MFS-5356, MFS-5889).
   *
   * ctx.vaseEligibleVariantIds — id вариантов букетов в корзине, которым
   * положена ваза; считает Liquid (snippets/free-vase-eligible.liquid через
   * sections/cart__main.liquid), JS этого правила не знает. Без ctx ваза
   * снимается только когда букетов не осталось вовсе.
   *
   * Чистая функция: возвращает { updates, attributes, removedAll } или null,
   * если снимать нечего.
   */
  function removalPlan(cart, keys, ctx) {
    const wanted = (Array.isArray(keys) ? keys : [keys]).filter(Boolean);
    if (!wanted.length) return null;

    const cfg = config();
    const opts = ctx || {};
    const all = lines(cart);
    const updates = {};
    const attributes = {};
    const drop = (item) => {
      updates[item.key] = 0;
    };
    const left = () => all.filter((item) => updates[item.key] !== 0);

    all.filter((item) => wanted.indexOf(item.key) !== -1).forEach(drop);
    if (!Object.keys(updates).length) return null;

    let remaining = left();

    // Членство — добавка к букету со скидкой, само по себе жить не должно.
    if (!remaining.some(isBouquetLine)) {
      const members = remaining.filter(isMembershipLine);
      if (members.length) {
        members.forEach(drop);
        attributes[cfg.offerAttribute] = '';
        remaining = left();
      }
    }

    // Ваза — только при букете, которому она положена.
    const eligible = Array.isArray(opts.vaseEligibleVariantIds)
      ? opts.vaseEligibleVariantIds.map(Number)
      : null;
    const vaseAllowed = remaining.some(
      (item) => isBouquetLine(item) && (!eligible || eligible.indexOf(Number(item.variant_id)) !== -1)
    );
    if (!vaseAllowed) {
      remaining.filter(isVaseLine).forEach(drop);
      remaining = left();
    }

    // Остались одни служебные строки — корзина по сути пуста.
    if (remaining.length && remaining.every(isServiceLine)) {
      remaining.forEach(drop);
      remaining = [];
    }

    const removedAll = remaining.length === 0;
    if (removedAll) attributes[cfg.offerAttribute] = '';

    return { updates, attributes, removedAll };
  }

  // ─── Брошенный клубный заказ ────────────────────────────────────────────────

  function isLegacyLine(item) {
    if (!item) return false;
    const cfg = config();
    if (idIn(cfg.legacyProductIds, 0, item.product_id)) return true;
    if (idIn(cfg.legacyVariantIds, 0, item.variant_id)) return true;
    return Array.isArray(cfg.legacyHandles) && cfg.legacyHandles.indexOf(item.handle) !== -1;
  }

  // Клубный букет: строка с меткой _club_landing (её ставят лендинги и клубная
  // PDP только товарам с тегом club-bouquet — по ней чекаут-расширения узнают
  // клубный заказ) либо вариант из списка Liquid (тег, кроме One time).
  function isClubBouquetLine(item) {
    if (!item) return false;
    const props = item.properties || {};
    if (String(props._club_landing) === 'true') return true;
    const hygiene = config().hygiene || {};
    return idIn(hygiene.clubBouquetVariantIds, 0, item.variant_id);
  }

  // Открытка клуба (myflowers-card, тег club-gift-card): кладёт её только шаг
  // /pages/club-card, без клубного заказа она сирота — список вариантов из Liquid.
  function isClubCardLine(item) {
    if (!item) return false;
    const hygiene = config().hygiene || {};
    return idIn(hygiene.clubCardVariantIds, 0, item.variant_id);
  }

  /**
   * План «вычистить брошенный клубный заказ» (покупатель отступил из клубного
   * чекаута и пошёл по сайту — MFS-5481): клубные букеты и легаси-строки
   * снимаются вместе с открыткой клуба; членство — тоже, если его не держит
   * обычная подписка, то есть остаётся букет И club_offer === 'subscribe' (так пишут форма товара и
   * тумблер на /cart; клубные потоки пишут club_offer: ''). Сироты и «остались
   * одни служебные строки» — removalPlan. Чистая функция: null, если клубных
   * и легаси строк нет — обычная корзина (в том числе с членством) не трогается.
   * Используется гигиеной на загрузке и One time-заказом клубной PDP
   * (CartService.prepareCheckout({ clear: MFClub.clubFlowPlan })).
   */
  function clubFlowPlan(cart, ctx) {
    const cfg = config();
    const all = lines(cart);
    const keys = all
      .filter(item => isClubBouquetLine(item) || isLegacyLine(item) || isClubCardLine(item))
      .map(item => item.key);
    if (!keys.length) return null;

    const attributes = (cart && cart.attributes) || {};
    const subscribed = attributes[cfg.offerAttribute] === 'subscribe';
    if (!subscribed) {
      membershipLines(cart).forEach(item => {
        if (keys.indexOf(item.key) === -1) keys.push(item.key);
      });
    }
    return removalPlan(cart, keys, ctx);
  }

  // Членство в сумме больше одной штуки (устаревшая вкладка, bfcache — Shopify
  // суммирует одинаковые строки) → первая строка 1, остальные 0.
  function membershipClampUpdates(cart) {
    const members = membershipLines(cart);
    const total = members.reduce((sum, item) => sum + (item.quantity || 0), 0);
    if (total <= 1) return null;
    const updates = {};
    members.forEach((item, index) => {
      updates[item.key] = index === 0 ? 1 : 0;
    });
    return updates;
  }

  function visibleItemCount(cart) {
    return lines(cart).reduce(
      (sum, item) => (isHiddenLine(item) ? sum : sum + (item.quantity || 0)),
      0
    );
  }

  function visibleTotal(cart) {
    return lines(cart).reduce(
      (sum, item) => (isHiddenLine(item) ? sum : sum + (item.final_line_price || 0)),
      0
    );
  }

  function isClubMember() {
    return config().isMember === true;
  }

  function planForCustomer() {
    return Number(config().planId) || Number(config().planTrial);
  }

  // ─── Операции ───────────────────────────────────────────────────────────────

  // Транспорт один — CartService.updateLines (очередь, кэш, события).
  // Файл подключён раньше cart-service.js (defer-порядок), поэтому на верхнем
  // уровне сервиса ещё нет; к моменту любого вызова (DOMContentLoaded) он есть.
  function post(payload) {
    const svc = window.CartService;
    if (!svc || typeof svc.updateLines !== 'function') {
      return Promise.reject(new Error('CartService is not available'));
    }
    return svc
      .updateLines({ updates: payload.updates, attributes: payload.attributes, sections: payload.sections })
      .then(result => result.data);
  }

  function setClubOffer(mode, options) {
    const opts = options || {};
    const payload = { attributes: {} };
    payload.attributes[config().offerAttribute] = mode;
    if (opts.sections) payload.sections = opts.sections;
    return post(payload);
  }

  function removeMembership(cart, options) {
    const opts = options || {};
    const membership = findMembershipLine(cart);
    if (!membership) return Promise.resolve(null);

    const payload = { updates: {}, attributes: {} };
    membershipLines(cart).forEach(item => {
      payload.updates[item.key] = 0;
    });
    payload.attributes[config().offerAttribute] = opts.offer || 'onetime';
    if (opts.sections) payload.sections = opts.sections;
    return post(payload);
  }

  /**
   * Инвариант MFS-5487 §3/§8: членство — добавка к букету со скидкой, само по
   * себе жить не должно, иначе покупатель оформит подписку без доставки.
   *
   * Возвращает промис с новой корзиной, если что-то делал, и null, если делать
   * было нечего. Принимает уже известную корзину (из ответа мутации), чтобы не
   * читать её повторно.
   */
  function enforceMembershipInvariant(cart, options) {
    const opts = options || {};
    if (!cart) {
      if (!window.CartService) return Promise.resolve(null);
      return window.CartService.getCart(true).then(fresh =>
        enforceMembershipInvariant(fresh, opts)
      );
    }

    if (!findMembershipLine(cart)) return Promise.resolve(null);
    if (hasBouquet(cart)) return Promise.resolve(null);

    // Режим корзины уходит вместе со строкой: иначе функция скидки продолжит
    // считать корзину клубной, а подтверждения у неё уже не будет.
    return removeMembership(cart, { sections: opts.sections, offer: '' });
  }

  // ─── Гигиена корзины на загрузке страницы ───────────────────────────────────
  //
  // Один /cart/update.js на всё, что надо поправить после рендера (бывшие
  // inline-скрипты theme.liquid и header):
  //  * брошенный клубный заказ и легаси-строки — clubFlowPlan по свежему
  //    /cart.js (ТОЛЬКО клубные строки и их сироты, а не корзина целиком:
  //    покупка, сделанная после возврата из чекаута, остаётся — QA MFS-5933
  //    п. 10.1); Liquid лишь говорит, есть ли что чистить (hygiene.needed), и
  //    называет варианты клубных букетов, которых JS по /cart.js не узнал бы;
  //  * членство ×N → ×1 (membershipClampUpdates);
  //  * сброс order_source: атрибут липкий — зашли с лендинга, бросили корзину,
  //    купили из каталога — а в заказе всё ещё landing. Считается по остатку
  //    строк после плана: наличие строки с меткой проверяется, а не только
  //    URL, иначе возврат из чекаута в корзину сбросил бы живой заказ с
  //    лендинга. Сам лендинг пропускаем — он перезапишет атрибут при заказе
  //    (карусели: data-snl-days-ahead и data-club-order-root; subscription-page
  //    рендерит каталог B, MFS-5847). Без строк на снятие — без GET, по
  //    hasLandingLine из Liquid.
  // На /cart ответ перерисовывает секцию (вместо reload), на остальных
  // страницах — счётчик шапки. Страница шага открытки клуба (MFS-5827 п.3)
  // исключена в Liquid.

  // Строка с лендинга: свойство _order_source: landing (ставят club-lp-order.js
  // и sub-new_carousel.js, читают Flow и пиксель Meta — см. CLAUDE.md)
  function hasLandingLine(items) {
    const cfg = config();
    return items.some(item => String((item.properties || {})._order_source) === cfg.landingSource);
  }

  function applyHygiene(plan) {
    const updates = plan.updates || {};
    const attributes = plan.attributes || {};
    if (!Object.keys(updates).length && !Object.keys(attributes).length) return Promise.resolve(null);

    const header = document.querySelector('.jsHeader [data-section-id]');
    const cartSection = document.querySelector('.shopify-section.jsCart .section[data-section-id]');
    const sections = [cartSection && cartSection.dataset.sectionId, header && header.dataset.sectionId].filter(Boolean);
    const jsCart = window.PXUTheme && window.PXUTheme.jsCart;
    const onCartPage = !!(jsCart && cartSection);
    const intent = onCartPage && Object.keys(updates).length ? jsCart.beginIntent() : 0;

    return post({ updates, attributes, sections })
      .then(data => {
        if (!data) return null;
        if (onCartPage) {
          jsCart.applyServiceResponse(data);
        } else if (window.PXUTheme && window.PXUTheme.jsHeader && data.sections) {
          window.PXUTheme.jsHeader.updateCartItemsCount(data.sections);
        }
        return data;
      })
      .finally(() => {
        if (intent) jsCart.endIntentIf(intent);
      });
  }

  function runHygiene() {
    const cfg = config();
    const hygiene = cfg.hygiene || {};
    const onLanding = !!document.querySelector('[data-snl-days-ahead], [data-club-order-root]');
    const sourceStale = cfg.orderSource === cfg.landingSource && !onLanding;

    let planned;
    if (!hygiene.needed) {
      const attributes = {};
      if (sourceStale && !cfg.hasLandingLine) attributes[cfg.sourceAttribute] = '';
      planned = Promise.resolve({ updates: {}, attributes });
    } else {
      const svc = window.CartService;
      planned = svc.getCart(true).then(cart => {
        const jsCart = window.PXUTheme && window.PXUTheme.jsCart;
        const ctx = {
          vaseEligibleVariantIds:
            jsCart && typeof jsCart.vaseEligibleVariantIds === 'function' ? jsCart.vaseEligibleVariantIds() : null,
        };
        const plan = clubFlowPlan(cart, ctx) || { updates: {}, attributes: {} };
        const clamp = membershipClampUpdates(cart);
        if (clamp) {
          Object.keys(clamp).forEach(key => {
            if (!(key in plan.updates)) plan.updates[key] = clamp[key];
          });
        }
        // Club-only bouquets: an old cart's One time club bouquet line goes on its own
        lines(cart).forEach(item => {
          if (idIn(hygiene.onetimeVariantIds, 0, item.variant_id) && !(item.key in plan.updates)) plan.updates[item.key] = 0;
        });
        const remaining = lines(cart).filter(item => plan.updates[item.key] !== 0);
        if (sourceStale && !hasLandingLine(remaining)) plan.attributes[cfg.sourceAttribute] = '';
        return plan;
      });
    }

    return planned
      .then(applyHygiene)
      .catch(error => console.error('[club-cart] hygiene failed', error));
  }

  // Сервис подключается позже этого файла (оба defer), поэтому ждём
  // DOMContentLoaded — к нему все defer-скрипты уже выполнились.
  if (window.CartService) {
    runHygiene();
  } else {
    document.addEventListener('DOMContentLoaded', runHygiene);
  }

  // ─── Реферальная ссылка ────────────────────────────────────────────────────
  //
  // MFS-5764: участник делится ссылкой на лендинг с ?ref=<код> (club-account-
  // worker, src/referral.ts). Код запоминается на 60 дней и кладётся в атрибут
  // корзины _club_ref — он доезжает в заказ, по нему Flow начисляет
  // пригласившему месяц после первой оплаты друга. Атрибут с «_» в чекауте не
  // показывается. Пишется, только когда расходится с корзиной и корзина не пуста.

  const REF_STORAGE = 'mf_club_ref';
  const REF_ATTRIBUTE = '_club_ref';
  const REF_TTL_MS = 60 * 24 * 3600 * 1000;
  const REF_FORMAT = /^[0-9a-z]{1,16}-[0-9a-f]{10}$/;

  function storedReferral() {
    try {
      const fromUrl = new URLSearchParams(window.location.search).get('ref');
      if (fromUrl && REF_FORMAT.test(fromUrl.trim().toLowerCase())) {
        const code = fromUrl.trim().toLowerCase();
        window.localStorage.setItem(REF_STORAGE, JSON.stringify({ code, at: Date.now() }));
        return code;
      }
      const saved = JSON.parse(window.localStorage.getItem(REF_STORAGE) || 'null');
      if (saved && REF_FORMAT.test(saved.code) && Date.now() - saved.at < REF_TTL_MS) return saved.code;
    } catch (e) {
      // private mode / blocked storage: the link still works for this page
    }
    return '';
  }

  function syncReferral() {
    const code = storedReferral();
    const svc = window.CartService;
    if (!code || !svc || typeof svc.getCart !== 'function') return;
    svc
      .getCart()
      .then(cart => {
        if (!cart || !cart.item_count) return null;
        const attrs = cart.attributes || {};
        if (attrs[REF_ATTRIBUTE] === code) return null;
        const payload = { attributes: {} };
        payload.attributes[REF_ATTRIBUTE] = code;
        return post(payload);
      })
      .catch(() => null);
  }

  // Each page load (a landing opened from the link) and every add to cart
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncReferral);
  else syncReferral();
  document.addEventListener('cart-updated', () => window.setTimeout(syncReferral, 0));

  window.MFClub = {
    config,
    isMembershipLine,
    isBouquetLine,
    isHiddenLine,
    membershipLines,
    findMembershipLine,
    hasBouquet,
    isVaseLine,
    isServiceLine,
    isLegacyLine,
    isClubBouquetLine,
    removalPlan,
    clubFlowPlan,
    membershipClampUpdates,
    visibleItemCount,
    visibleTotal,
    isClubMember,
    planForCustomer,
    setClubOffer,
    removeMembership,
    enforceMembershipInvariant,
    runHygiene,
  };
})();
